/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scrollview';

interface KeyboardScrollViewProps {
  children: JSX.Element;
  paddingBottom?: number;
  justifyContent?: string;
}

function KeyboardScrollView(props: KeyboardScrollViewProps) {
  const {children, paddingBottom, justifyContent} = props;

  return (
    <KeyboardAwareScrollView
      paddingBottom={paddingBottom}
      nestedScrollEnabled
      keyboardShouldPersistTaps="handled"
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: justifyContent || 'center',
        minWidth: '100%',
        paddingBottom: paddingBottom || 0,
      }}>
      {children}
    </KeyboardAwareScrollView>
  );
}

export default KeyboardScrollView;
